<template>
<div class="chapter">
<div class="inner_page">
<p class="p12"><span class="t15">This one is for anyone that has ever felt like boxes are for cats to sit in, not for people to be labeled into. I had fun with the characters in this novel, and they took some pretty surprising turns. Normal is just a setting in laundry, nothing more, and I hope these characters make you smile and laugh as much as they did for me. Thank you all for your continued support, affection, and letters. And thank you, as always, to Scott, who lets me get away with not doing laundry and staying up until two in the morning when I really want to finish a story.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 006.vue?2ebc6d6f